import * as React from 'react';
import { Redirect } from 'react-router';
import { Props } from 'reactstrap/lib/Dropdown';
import LoadingOverlay from '../../common/LoadingOverlay';
import * as moment from 'moment';
import { getAllProspects } from '../../../api/Prospect';
import { exportActivityData } from '../../../utilities/exportLog';

interface State {
    logDownloaded: boolean;
}

class ProspectSignupReportPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            logDownloaded: false
        };
    }

    async componentDidMount() {
        const startDateString = '2020-01-01';
        const endDateString = '2021-01-01';
        let checkResult = await getAllProspects(startDateString, endDateString);
        if (checkResult.success && checkResult.data) {
            exportActivityData(
                checkResult.data,
                false,
                moment(startDateString),
                moment(endDateString),
                true
            );
            this.setState({
                logDownloaded: true
            });
        }
    }

    render() {
        if (this.state.logDownloaded === true) {
            return <Redirect to={{ pathname: '/admin' }} />;
        } else {
            return (
                <div className="position-relative w-100 h-75">
                    <LoadingOverlay show={true} inBootstrapColumn={false} />
                </div>
            );
        }
    }
}

export default ProspectSignupReportPage;



// WEBPACK FOOTER //
// ./src/components/pages/admin/ProspectSignupReportPage.tsx